import {useReposAppPayload} from '@github-ui/code-view-shared/contexts/FilesPageInfoContext'
import {usePath} from '@github-ui/code-view-shared/contexts/PathContext'
import type {DeleteInfo, WebCommitInfo} from '@github-ui/code-view-types'
import {useCurrentRepository} from '@github-ui/current-repository'
import {DiffPlaceholder} from '@github-ui/diffs/DiffParts'
import {Flash, Heading} from '@primer/react'

import {EditingForkBanner} from '../blob-edit/banners/EditingForkBanner'
import {EditIssues} from '../blob-edit/EditIssues'
import {DiffEntry} from './DeleteViewEntry'

export function DeleteViewContent({deleteInfo, webCommitInfo}: {deleteInfo: DeleteInfo; webCommitInfo: WebCommitInfo}) {
  const path = usePath()
  const {helpUrl} = useReposAppPayload()
  const repo = useCurrentRepository()

  if (webCommitInfo.shouldFork || webCommitInfo.shouldUpdate || webCommitInfo.lockedOnMigration) {
    return <EditIssues binary={false} helpUrl={helpUrl} webCommitInfo={webCommitInfo} repositoryName={repo.name} />
  }

  return (
    <div className="container-xl mx-auto">
      <Heading as="h1" className="sr-only">{`Deleting ${deleteInfo.isBlob ? '' : 'directory '}${
        repo.name
      }/${path}. Commit changes to save.`}</Heading>
      <DiffPlaceholder />
      {webCommitInfo.forkedRepo && (
        <EditingForkBanner
          forkName={webCommitInfo.forkedRepo.name}
          forkOwner={webCommitInfo.forkedRepo.owner}
          canCreatePullRequest={webCommitInfo.canCreatePullRequest}
        />
      )}
      {deleteInfo.truncated && (
        <Flash variant="warning" className="mb-2">
          The diff you&apos;re trying to view is too large. We only load the first 1000 changed files.
        </Flash>
      )}

      {deleteInfo.diffs.map((diff, index) => {
        // eslint-disable-next-line @eslint-react/no-array-index-key
        return <DiffEntry key={index} diff={diff} index={index} />
      })}
    </div>
  )
}
